import playWhenInView from './playWhenInView.js';

// JavaScript Document
$(document).ready(function ($) {


  //-- Animate in object
  var animobjects = $('.animatedin').length;
  var currobj = 0;

  if (animobjects != 0) {

    $('.animatedin').each(function () {
      var obj = $(this);

      setTimeout(function () {
        obj.addClass('in');

        setTimeout(function () {
          obj.addClass('stop');
        }, 300)

      }, 80 * currobj);

      currobj += 1;
    });
  }

  //-- Header sizing on scroll
  $(window).on('scroll', function () {
    changeHeader();
  });


  //-- Change header on scroll
  changeHeader();

  function changeHeader() {
    if ($(window).scrollTop() > 80) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  };


  //-- Mobile menu
  $('.btn-mobilemenu').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('showmenu');
  });

  $('.overlay, .btn-closemenu').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('showmenu');
  });


  //-- Sticky content nav
  if ($('.content__nav').length != 0) {
    console.log('this');
    $('.content__nav').stick_in_parent({
      parent: $('.content')
    });
  }


  //-- Show email signup
  $('.btn-signupEmail').on('click', function (e) {
    e.preventDefault();
    var emailSignup = $(this).parents('.form-intSignup').find('.int-signup__sec')
    var emailButton = $(this).parents('.form-intSignup').find('.int-signup__btnEmail');

    $('.int-signup__sec').removeClass('d-none');
    emailButton.hide();
  });


  // Inject SVGs
  var SVGsToInject = document.querySelectorAll('img.inject-svg-static'),
          injectorOptions = {
            evalScripts: 'once',
            each: function(svg) {

            }
          };

  SVGInjector(SVGsToInject, injectorOptions, function(totalSVGsInjected) { });


  // Tooltips
  if ($('[data-toggle="tooltip"]').length != 0) {
    $('[data-toggle="tooltip"]').tooltip({})
  };


  // Sticky integrations filters bar
  if ($('.integrations-filters').length != 0 && $(window).width() > 767) {

    $('.integrations-filters').stick_in_parent({
      offset_top: 92
    });


    $(window).smartresize(function () {
      if ($(window).width() > 767) {
        $('.integrations-filters').stick_in_parent({
          offset_top: 92
        });
      }
      else {
        $('.integrations-filters').trigger('sticky_kit:detach');
      }
    });

  };

});


(function ($, sr) {

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced() {
      var obj = this, args = arguments;
      function delayed() {
        if (!execAsap)
          func.apply(obj, args);
        timeout = null;
      };

      if (timeout)
        clearTimeout(timeout);
      else if (execAsap)
        func.apply(obj, args);

      timeout = setTimeout(delayed, threshold || 100);
    };
  }
  // smartresize
  jQuery.fn[sr] = function (fn) { return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery, 'smartresize');



// MB
$('#expenses_videos').on('click', '.video-selector:not(.mobile)', function () {
  let selectedVideo = $(this).data('name');
  $('video.active').removeClass('active').fadeOut(function () {
    $('video[data-name="' + selectedVideo + '"]')
      .addClass('active')
      .fadeIn(function () {
        $(this)[0].play();
      });
  });

  $('.video-selector').removeClass('active');

  $('.video-selector p').css('opacity', 0);
  $(this)
    .addClass('active')
    .find('.video-text-expanded')
    .slideDown(function () {
      $('.video-selector:not(.active) .video-text-expanded').slideUp();
      $(this).find('p').css('opacity', 1);
    });
});

$(document).ready(function ($) {
  // videos: play when scrolled into view, pause when out
  // var videos = document.querySelectorAll('.featblocks--expenses video');
  const videos = document.querySelectorAll('video');
  playWhenInView(videos);

  // expand/disable all video-selectors in mobile view (expenses page)
  if (window.innerWidth < 768) {
    $('.video-selector')
        .removeClass('active')
        .addClass('mobile')
        .find('.video-text-expanded')
        .slideDown()
        .find('p').css('opacity', 1);;
  }

  $('img.int-topfeat').each(function() {
    let src = $(this).attr('src');
    if (src.includes('sales-connect')) {
      let width = $(this).width();
      let brandLogoSrc = $('main').attr('data-logo-src');
      $(`<img src="${brandLogoSrc}" class="int-connect-logo" style="width: 40%" alt="logo" />`).insertBefore($(this));
    }
  });
  $('.integration-featureset-addtl img').each(function() {
    let src = $(this).attr('src');
    let width = $(this).width();
    let brandLogoSrc = $('main').attr('data-logo-src');
    if (src.includes('connect-dynamic')) {
      $(`<img src="${brandLogoSrc}" class="int-connect-logo int-connect-logo-addtl" style="width: 50%" alt="logo" />`).insertBefore($(this));
    } else if (src.includes('getting-data-in-dynamic')) {
      $(`<img src="${brandLogoSrc}" class="int-connect-logo int-connect-logo-addtl" style="width: 40%" alt="logo" />`).insertBefore($(this));
    } else if (src.includes('dynamic-calendar')) {
      $(`<img src="${brandLogoSrc}" class="int-connect-logo int-connect-logo-calendar" style="width: 35%" alt="logo" />`).insertBefore($(this));
    } else if (src.includes('original-receipt')) {
      $(`<img src="${brandLogoSrc}" class="int-connect-logo int-connect-logo-receipt" style="width: 35%" alt="logo" />`).insertBefore($(this));
    }
  });

});

document.addEventListener("DOMContentLoaded", yall);
